/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-else-return */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import i18n from 'i18next';
import useAPIError from '../../hooks/useAPIError';
import { AhorroObj, AhorroPorMesObj } from '../../types/Types';
import AhorrosService from '../../services/AhorrosService';
import { useAuthStore } from '../../store/AuthContext';
import { useAppStore } from '../../store/AppContext';
import 'moment/locale/eu';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/ca';
import 'moment/locale/gl';
import { PriceFormatter } from '../../utils/PriceFormatter';
// eslint-disable-next-line import/named
import { AhorrosHelper } from './AhorrosHelper';
import { TarjetaService } from '../../services';
import { CryptoUtil } from '../../utils/CryptoUtil';
import useSessionChecking from '../../hooks/useSessionChecking';
import { StorageHelper } from '../../utils/StorageHelper';
import { BackMappings } from '../../utils/BackMappings';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import { GtmConstants } from '../../utils/GtmConstants';
import NotFound from '../NotFound';
import AhorrosCaprabo from './indexCaprabo';
import AhorrosEroski from './indexEroski';
import { CookieHelper } from '../../utils/CookieHelper';
import { HostProvider } from '../../utils/HostProvider';

const Ahorros: FC = () => {
  const { t } = useTranslation();

  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.AHORROS);
  useSessionChecking(BackMappings.AHORROS, setGoOn, goOn);
  useDatalayerEvents(GtmConstants.MIS_VENTAJAS);
  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const { moneda } = dataUser.user;
  const { addError, addErrorBack } = useAPIError();
  const [ahorroXMes, setAhorroXMes] = useState<AhorroPorMesObj[]>([]);
  const [currentMonth, setCurrentMonth] = useState<number>(moment().month());
  const [ahorroCurrentMonth, setAhorroCurrentMonth] = useState<number>(0);
  const [isAhorroCurrentMonth, setIsAhorroCurrentMonth] = useState<boolean>(
    false,
  );
  const [inputCurrentMonth, setInputCurrentMonth] = useState<number>(
    moment().month(),
  );
  const [inputCurrentYear, setInputCurrentYear] = useState<number>(
    moment().year(),
  );
  const [saldo, setSaldo] = useState<number>(0);
  const [puntosTravel, setPuntosTravel] = useState<number>(0);
  const [pieData, setPieData] = useState<any>([]);
  const [allAhorroData, setAllAhorroData] = useState<AhorroObj[]>([]);
  const [ahorroData, setAhorroData] = useState<AhorroObj>();
  const [load, setLoad] = useState<boolean>(false);
  const [view, setView] = useState<boolean>(false);
  const [backError] = useState(false as boolean);
  const [tipoUsuarioTarjeta, setTipoUsuarioTarjeta] = useState<number>(-1);
  const [ahorroTotalAnual, setAhorroTotalAnual] = useState<number>(0);
  const [
    ahorroPotencialOroAnual,
    setAhorroPotencialOroAnual,
  ] = useState<number>(0);
  const [totalCompras, setTotalCompras] = useState<number>(0);

  const [isByDate, setIsByDate] = useState<boolean>(false);
  const [months, setMonths] = useState<any[]>([]);
  const [ahorroDataSort, setAhorroDataSort] = useState<any>(null);
  const [currentDateCombo, setCurrentDateCombo] = useState<any>('');
  const [firstCharge, setFirstCharge] = useState(true);

  const retrieveAhorros = () => {
    AhorrosService.retrieveAhorrosTicketTotalInfo()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setView(true);
          addErrorBack(response.data);
        } else {
          setView(true);
          if (response.data.ahorroTotalAnual) {
            setAhorroTotalAnual(response.data.ahorroTotalAnual);
          }
          if (response.data.ahorroPotencialOroAnual) {
            setAhorroPotencialOroAnual(response.data.ahorroPotencialOroAnual);
          }
          if (response.data.saldo) {
            setSaldo(response.data.saldo);
          }
          if (response.data.totalCompras) {
            setTotalCompras(response.data.totalCompras);
          }
          if (response.data.puntosTravel) {
            setPuntosTravel(response.data.puntosTravel);
          }
          if (response.data?.pojo !== null) {
            const dataTablaResponse = response.data;
            const arrayMonths: AhorroPorMesObj[] = [];
            if (dataTablaResponse.pojos && dataTablaResponse.pojos.length > 0) {
              const ahorroObject = dataTablaResponse.pojos as AhorroObj[];
              if (currentDateCombo) {
                setCurrentMonth(currentMonth);
                setInputCurrentMonth(inputCurrentMonth);
                setInputCurrentYear(inputCurrentYear);
                setAllAhorroData(dataTablaResponse.pojos);
              } else {
                setCurrentMonth(ahorroObject[0].mes % ahorroObject[0].anio);
                setInputCurrentMonth(
                  ahorroObject[0].mes % ahorroObject[0].anio,
                );
                setInputCurrentYear(ahorroObject[0].anio);
                setAllAhorroData(dataTablaResponse.pojos);
              }
              response.data.ahorrosPorMesList.forEach((value) => {
                arrayMonths.push({
                  month: value.month,
                  year: value.year,
                  ahorro: value.ahorro,
                });
              });
              setAhorroXMes(arrayMonths.reverse());
            }
          }
          setFirstCharge(false);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const retrieveAhorrosByDate = (periodo: string) => {
    const data = {
      periodo,
    };
    AhorrosService.retrieveAhorrosTableInfo(data)
      .then((response) => {
        if (response.data.error === true) {
          setView(true);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          setView(true);
          let month = periodo.slice(4, 6);
          if (month.slice(0, 1) === '0') {
            month = month.slice(-1);
          }
          setInputCurrentMonth(Number(month));
          setInputCurrentYear(Number(periodo.slice(0, 4)));
          setAhorroData(response.data.pojo);
          setIsByDate(true);

          if (response.data.pojo) {
            setPieData([
              response.data.pojo.porcentSocio,
              response.data.pojo.porcentOfertas,
              response.data.pojo.porcentPuntosTravel,
            ]);
            if (response.data.pojo.ahorroTotalAnual !== 'undefined') {
              setAhorroTotalAnual(response.data.pojo.ahorroTotalAnual);
            }
            if (response.data.pojo.ahorroPotencialOroAnual !== 'undefined') {
              setAhorroPotencialOroAnual(
                response.data.pojo.ahorroPotencialOroAnual,
              );
            }
          }
          if (response.data.saldo) {
            setSaldo(response.data.saldo);
          }
          if (response.data.totalCompras) {
            setTotalCompras(response.data.totalCompras);
          }
          if (response.data.puntosTravel) {
            setPuntosTravel(response.data.puntosTravel);
          }
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const isOro = () => {
    TarjetaService.getTipoUsuarioTarjeta()
      .then((response) => {
        if (response.data !== '') {
          if (tipoUsuarioTarjeta < 0) {
            setTipoUsuarioTarjeta(response.data);
          } else {
            sessionStorage.setItem(
              'tipoUsuarioTarjeta',
              CryptoUtil.encrypt(response.data.toString()),
            );
          }
        } else {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '') {
      if (!load) {
        setLoad(true);
        retrieveAhorros();
        if (isEroski) {
          isOro();
        }
      }
    }
  });

  useEffect(() => {
    if (dataUser.user.token !== '') retrieveAhorros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  useEffect(() => {
    if (ahorroXMes.length > 0) {
      const tempArray: any[] = [];
      ahorroXMes.forEach((date) => {
        let month = String(date.month).slice(4, 6);
        if (month.slice(0, 1) === '0') {
          month = month.slice(-1);
        }
        tempArray.push({
          month: moment()
            .month(Number(month) - 1)
            .locale(dataApp.lang)
            .format('MMMM'),
          year: date.year,
          periodo: date.month,
        });
      });
      if (currentDateCombo === '' && tempArray.length > 0) {
        const comboMonth = tempArray.reverse()[0];
        setCurrentDateCombo(comboMonth.periodo);
      }
      setMonths(tempArray.reverse());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ahorroXMes]);

  useEffect(() => {
    if (!isByDate) {
      const monthConcat = Number(
        String(inputCurrentMonth).length === 1
          ? String(inputCurrentYear).concat('0', String(inputCurrentMonth))
          : String(inputCurrentYear).concat('', String(inputCurrentMonth)),
      );
      const data = allAhorroData.filter(
        (a) => a.anio === inputCurrentYear && a.mes === monthConcat,
      )[0];
      setAhorroData(data);
      if (data !== undefined) {
        if (!isAhorroCurrentMonth) {
          setAhorroCurrentMonth(data.ahorroTotal);
          setIsAhorroCurrentMonth(true);
        }
        setPieData([
          data.porcentSocio,
          data.porcentOfertas,
          data.porcentPuntosTravel,
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allAhorroData]);

  useEffect(() => {
    if (ahorroData !== undefined) {
      const tempValuesArray: any[] = [];
      if (ahorroData !== undefined && ahorroData !== null) {
        const tempKeysArray: string[] = Object.keys(ahorroData);
        Object.values(ahorroData).forEach((value, index) => {
          if (
            value > 0 &&
            tempKeysArray[index] !== 'mes' &&
            tempKeysArray[index] !== 'anio' &&
            tempKeysArray[index] !== 'ahorroPertenenciaClub' &&
            tempKeysArray[index] !== 'ahorroOfertaMasiva' &&
            tempKeysArray[index] !== 'ahorroPuntosTravel' &&
            tempKeysArray[index] !== 'porcentSocio' &&
            tempKeysArray[index] !== 'porcentOfertas' &&
            tempKeysArray[index] !== 'porcentPuntosTravel' &&
            tempKeysArray[index] !== 'ahorroPotencialOroAnual' &&
            tempKeysArray[index] !== 'ahorroPotencialOro' &&
            tempKeysArray[index] !== 'ahorroTotal' &&
            tempKeysArray[index] !== 'ahorroTotalAnual'
          )
            tempValuesArray.push({ key: tempKeysArray[index], val: value });
        });
        tempValuesArray.sort((a, b) => {
          if (a.val < b.val) {
            return 1;
          }
          if (a.val > b.val) {
            return -1;
          }
          return 0;
        });
      }

      setAhorroDataSort(tempValuesArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ahorroData]);

  AhorrosHelper.initializeListeners();

  const priceFormatter = (cell: any) => {
    return PriceFormatter.formatStringAsPrice(cell as string, '');
  };

  const getTitleText = () => {
    if (dataApp.lang === 'eu') {
      return (
        <>
          {t('ahorros.has-ahorrado')}
          {moment(currentMonth, 'MM').locale(dataApp.lang).format('MMMM')}
          {t('ahorros.en')}{' '}
        </>
      );
    } else {
      return (
        <>
          {t('ahorros.super-en')}{' '}
          {moment(currentMonth, 'MM').locale(dataApp.lang).format('MMMM')}
        </>
      );
    }
  };
  if (goOn) {
    if (view) {
      if (isEroski) {
        if (!CookieHelper.isBloqueada()) {
          return (
            <>
              <AhorrosEroski
                view={view}
                dataUser={dataUser}
                ahorroCurrentMonth={ahorroCurrentMonth}
                getTitleText={getTitleText}
                ahorroXMes={ahorroXMes}
                ahorroDataSort={ahorroDataSort}
                retrieveAhorrosByDate={retrieveAhorrosByDate}
                months={months}
                inputCurrentYear={inputCurrentYear}
                inputCurrentMonth={inputCurrentMonth}
                isByDate={isByDate}
                setIsByDate={setIsByDate}
                ahorroData={ahorroData}
                priceFormatter={priceFormatter}
                pieData={pieData}
                ahorroTotalAnual={ahorroTotalAnual}
                ahorroPotencialOroAnual={ahorroPotencialOroAnual}
                dataApp={dataApp}
                moneda={moneda}
                tipoUsuarioTarjeta={tipoUsuarioTarjeta}
                saldo={saldo}
                totalCompras={totalCompras}
                currentMonth={currentMonth}
                puntosTravel={puntosTravel}
                backError={backError}
                currentDateCombo={currentDateCombo}
                setCurrentDateCombo={setCurrentDateCombo}
              />
            </>
          );
        }
        return <NotFound />;
      } else if (isCaprabo) {
        if (!CookieHelper.isBloqueada()) {
          return (
            <>
              <AhorrosCaprabo
                view={view}
                dataUser={dataUser}
                ahorroCurrentMonth={ahorroCurrentMonth}
                getTitleText={getTitleText}
                ahorroXMes={ahorroXMes}
                ahorroDataSort={ahorroDataSort}
                retrieveAhorrosByDate={retrieveAhorrosByDate}
                months={months}
                inputCurrentYear={inputCurrentYear}
                inputCurrentMonth={inputCurrentMonth}
                isByDate={isByDate}
                setIsByDate={setIsByDate}
                ahorroData={ahorroData}
                priceFormatter={priceFormatter}
                pieData={pieData}
                ahorroTotalAnual={ahorroTotalAnual}
                ahorroPotencialOroAnual={ahorroPotencialOroAnual}
                dataApp={dataApp}
                moneda={moneda}
                tipoUsuarioTarjeta={tipoUsuarioTarjeta}
                saldo={saldo}
                totalCompras={totalCompras}
                currentMonth={currentMonth}
                puntosTravel={puntosTravel}
                backError={backError}
                currentDateCombo={currentDateCombo}
                setCurrentDateCombo={setCurrentDateCombo}
              />
            </>
          );
        }
        return <NotFound />;
      }
      return <NotFound />;
    }
    return <></>;
  }
  return <></>;
};

export default Ahorros;
